var React = require('react');

function AngleBottom (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 3.002c0-.284.123-.566.359-.763a1.006 1.006 0 0 1 1.409.126L7.997 7.4l4.235-5.043c.354-.42.984-.478 1.409-.126a.988.988 0 0 1 .127 1.398L7.997 10.5 2.232 3.638A.986.986 0 0 1 2 3.002zM14 13a1 1 0 0 1-1 1H3a1 1 0 1 1 0-2h10a1 1 0 0 1 1 1z"}));
}

AngleBottom.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = AngleBottom;

AngleBottom.default = AngleBottom;
